<template>
  <div class="containar">
    <div class="clock-contents-block">
        <div class="">
          <div id="barclock" class="clock-previewca barfont" v-bind:class="[foreColor, borderRadius]">
            <span class="bartime">{{ hours }}:{{ minutes }}<span class="barampm">{{ ampm }}</span></span>
          </div>
        </div>
        <div class="set">
          <h3>グラデーション選択</h3>
          <div class="gradient-grid">
            <label class="gradient-option" :class="{ active: color === 'green' }">
              <input type="radio" value="green" v-model="color" />
              <div class="gradient-preview green-gradient-background"></div>
            </label>
            <label class="gradient-option" :class="{ active: color === 'blue' }">
              <input type="radio" value="blue" v-model="color" />
              <div class="gradient-preview blue-gradient-background"></div>
            </label>
            <label class="gradient-option" :class="{ active: color === 'red' }">
              <input type="radio" value="red" v-model="color" />
              <div class="gradient-preview red-gradient-background"></div>
            </label>
            <label class="gradient-option" :class="{ active: color === 'sky' }">
              <input type="radio" value="sky" v-model="color" />
              <div class="gradient-preview sky-gradient-background"></div>
            </label>
            <label class="gradient-option" :class="{ active: color === 'gray' }">
              <input type="radio" value="gray" v-model="color" />
              <div class="gradient-preview gray-gradient-background"></div>
            </label>
            <label class="gradient-option" :class="{ active: color === 'yellow' }">
              <input type="radio" value="yellow" v-model="color" />
              <div class="gradient-preview yellow-gradient-background"></div>
            </label>
            <label class="gradient-option" :class="{ active: color === 'lush' }">
              <input type="radio" value="lush" v-model="color" />
              <div class="gradient-preview lush-gradient-background"></div>
            </label>
            <label class="gradient-option" :class="{ active: color === 'moon' }">
              <input type="radio" value="moon" v-model="color" />
              <div class="gradient-preview moon-gradient-background"></div>
            </label>
            <label class="gradient-option" :class="{ active: color === 'rose' }">
              <input type="radio" value="rose" v-model="color" />
              <div class="gradient-preview rose-gradient-background"></div>
            </label>
            <label class="gradient-option" :class="{ active: color === 'steel' }">
              <input type="radio" value="steel" v-model="color" />
              <div class="gradient-preview steel-gradient-background"></div>
            </label>
          </div>
          
          <h3>かたち</h3>
          <div class="toggle-group">
            <label class="toggle-option" :class="{ active: radius === 'round-border' }">
              <input type="radio" value="round-border" v-model="radius" />
              <span class="toggle-label">丸型</span>
            </label>
            <label class="toggle-option" :class="{ active: radius === 'square-border' }">
              <input type="radio" value="square-border" v-model="radius" />
              <span class="toggle-label">角型</span>
            </label>
          </div>
          
          <h3>配信ソフト用URL</h3>
          <div class="url-description">
            <p>各項目を選択するとURLが自動的に生成されます。</p>
            <p>OBSならば、ソースの「ブラウザ」を追加→下記URLを入力すると表示できます。</p>
          </div>
          <div class="url-container">
            <input :value="urlInput + '?color=' + color + '&radius=' + radius" id="target" type="text" readonly class="url-input" />
            <button @click="copy" class="url-copy-btn">
              <span>コピー</span>
            </button>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  name: "app",
  data() {
    return {
      hours: "",
      minutes: "",
      ampm: "",
      color: 'green',
      radius: 'round-border',
      urlInput:'https://ruri.info/tool/barclock'
    };
  },

  computed: {
    foreColor: function() {
      if (this.color === 'green') {
        return 'green-gradient-background';
      }
      else if (this.color === 'blue') {
        return 'blue-gradient-background';
      }
      else if (this.color === 'red') {
        return 'red-gradient-background';
      }
      else if (this.color === 'sky') {
        return 'sky-gradient-background';
      }
      else if (this.color === 'gray') {
        return 'gray-gradient-background';
      }
      else if (this.color === 'yellow') {
        return 'yellow-gradient-background';
      }
      else if (this.color === 'lush') {
        return 'lush-gradient-background';
      }
      else if (this.color === 'moon') {
        return 'moon-gradient-background';
      }
      else if (this.color === 'rose') {
        return 'rose-gradient-background';
      }
      else if (this.color === 'steel') {
        return 'steel-gradient-background';
      }
      else {
        return '';
      }
    },
    borderRadius: function() {
      return this.radius;
    }
  },
  mounted: function () {
    setInterval(this.updateTime, 1000);
  },
  methods: {
    updateTime: function () {
      let currentdate = new Date();
      let hours = currentdate.getHours();
      this.ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // 0時は12時として扱う
      this.hours = this.zeroPadding(hours, 2);
      this.minutes = this.zeroPadding(currentdate.getMinutes(), 2);
    },
    zeroPadding: function (num, len) {
      let zero = "";

      // 0の文字列を作成
      for (var i = 0; i < len; i++) {
        zero += "0";
      }

      // zeroの文字列と、数字を結合し、後ろ２文字を返す
      return (zero + num).slice(-len);
    },
    copy () {
      if(navigator.clipboard){
        navigator.clipboard.writeText(this.urlInput + '?color=' + this.color + '&radius=' + this.radius)
        console.log('コピー完了')
        return true
      } else {
        return false
      }
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');

p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}
.containar{
  margin: 0 auto;
  max-width: 767px;
}

h3{
  font-size: 14px;
  margin-top: 24px;
}

.clock-contents-block{
  text-align: left;
  display: -webkit-flex;
	display: flex;
	-webkit-flex-wrap: nowrap;
	flex-wrap: nowrap;
	align-items: center;
  margin: 24px auto;
  min-width: 0;
  height: 100%;
}

@media screen and (max-width: 630px) {
  .clock-contents-block{
    display: block;
    margin: 0 auto;
  }

  .set{
    margin-top:24px;
    margin-left: 0px!important;
  }
}


#barclock {
  width: 220px;
  height: 70px;
  padding: 14px 42px 0px 42px;
  margin: 12px;
  color: #fff;
  -webkit-align-self: flex-start;
  align-self: flex-start;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
}


.bartime {
  letter-spacing: 0.05em;
  font-size: 52px;
  line-height: 0.75em;
  margin-bottom: 10px;
}

.barampm {
  font-size: 0.7em;
  vertical-align: 2px;
  margin-left: 5px;
}

.set{
  padding: 8px 12px 24px 12px;
  background-color: #FFFEF9;
  border-radius: 10px;
  -webkit-align-self: flex-start;
	align-self: flex-start;
  box-sizing: border-box;
  margin-left: 24px;
}



.blue-gradient-background {
  background: linear-gradient(260deg,#FBDA61 0%, #FF5ACD 100%);
  background-size: 180% 180%;
  animation: blue-gradient-animation 10s ease infinite;
}

@keyframes blue-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.red-gradient-background {
  background: linear-gradient(43deg,#4158D0 0%, #C850C0 46%, #FFCC70 100%);
  background-size: 180% 180%;
  animation: red-gradient-animation 6s ease infinite;
}

@keyframes red-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.green-gradient-background {
  background: linear-gradient(256deg,#0093E9 0%,#a1efc6 46%, #80D0C7 100%);
  background-size: 240% 240%;
  animation: green-gradient-animation 10s ease infinite;
}

@keyframes green-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.sky-gradient-background {
  background: linear-gradient(260deg, #D9AFD9 0%, #97D9E1 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
}

@keyframes sky-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.gray-gradient-background {
  background: linear-gradient(260deg, #304352 0%, #d7d2cc 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
}

@keyframes gray-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.yellow-gradient-background {
  background: linear-gradient(260deg, #F3F9A7 0%, #CAC531 100%);
  background-size: 240% 240%;
  animation: yellow-gradient-animation 12s ease infinite;
}

@keyframes yellow-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.lush-gradient-background {
  background: linear-gradient(260deg, #56ab2f 0%, #a8e063 100%);
  background-size: 240% 240%;
  animation: lush-gradient-animation 12s ease infinite;
}

@keyframes lush-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.moon-gradient-background {
  background: linear-gradient(260deg, #4e54c8 0%, #8f94fb 100%);
  background-size: 240% 240%;
  animation: moon-gradient-animation 12s ease infinite;
}

@keyframes moon-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.rose-gradient-background {
  background: linear-gradient(260deg, #f4c4f3 0%, #fc67fa 100%);
  background-size: 240% 240%;
  animation: rose-gradient-animation 12s ease infinite;
}

@keyframes rose-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.steel-gradient-background {
  background: linear-gradient(260deg, #1F1C2C 0%, #928DAB 100%);
  background-size: 240% 240%;
  animation: steel-gradient-animation 12s ease infinite;
}

@keyframes steel-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}


.round-border {
  border-radius: 100vh;
}

.square-border {
  border-radius: 10px;
}

.barfont{
  font-family: "Outfit", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
}

/* Gradient Selection */
.gradient-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  margin-top: 12px;
}

.gradient-option {
  position: relative;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 6px;
  transition: all 0.2s ease;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.gradient-option:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.gradient-option.active {
  border-color: #0f172a;
  box-shadow: 0 0 0 2px rgba(15, 23, 42, 0.2);
}

.gradient-option input[type="radio"] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.gradient-preview {
  width: 100%;
  height: 32px;
  border-radius: 4px;
  margin: 0;
}

/* Toggle Options (かたち) */
.toggle-group {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.toggle-option {
  position: relative;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 6px;
  transition: all 0.2s ease;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  flex: 1;
}

.toggle-option:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.toggle-option.active {
  border-color: #0f172a;
  box-shadow: 0 0 0 2px rgba(15, 23, 42, 0.2);
  background: #ebf8ff;
}

.toggle-option input[type="radio"] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.toggle-label {
  display: block;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  color: #4a5568;
  transition: color 0.2s ease;
}

.toggle-option.active .toggle-label {
  color: #0f172a;
}

/* URL Section */
.url-description {
  margin-top: 12px;
}

.url-description p {
  color: #4a5568;
  font-size: 13px;
  line-height: 1.4;
  margin-bottom: 8px;
}

.url-container {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.url-input {
  flex: 1;
  height: 2.4em;
  padding: 0 12px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  font-size: 13px;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  background: #f8f9fa;
}

.url-input:focus {
  outline: none;
  box-shadow: 0 0 0 2px #0f172a;
  background: #fff;
}

.url-copy-btn {
  height: 2.4em;
  padding: 0 16px;
  background: #0f172a;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.url-copy-btn:hover {
  background: #0f172a;
  transform: translateY(-1px);
}

.url-copy-btn:active {
  transform: translateY(0);
}
</style>

